import { FMCarouselFragment } from '../../../models/experiencefragments/fm-carousel';
import { FMBannersProps } from '../../sections/fm-vehicle-portal/hook/use-fm-banners';
import { FMFiftyFiftyProps } from '../../sections/fm-vehicle-portal/hook/use-fm-fifty-fifty';

export const formatTitle = (
    componentProps: FMBannersProps | FMFiftyFiftyProps | FMCarouselFragment
) => {
    const title: [] | string =
        typeof componentProps?.title === 'object'
            ? (componentProps?.title as any)?.props?.children
            : componentProps?.title;

    if (typeof title === 'string') {
        return formatString(title);
    } else if (typeof title === 'object') {
        return title
            .map((item: any) => {
                if (typeof item === 'string') {
                    return formatString(item);
                } else if (typeof item === 'object') {
                    return formatString(item?.props?.children);
                }
            })
            .join(' ');
    }
};

export const formatString = (input: string | undefined) => {
    return input
        ?.toLowerCase()
        ?.replace(/\[disclaimer\]/g, '')
        ?.replace(/[^a-zA-Z0-9 ]/g, ' ')
        ?.replace(/\s+/g, ' ')
        ?.trim();
};
